module.exports = "<div [ngClass]='{\"sticky\":fixedPosition, \"sticky-bottom\":absolutePosition, \"transition\":progress}' [ngStyle]='fixedStyle'>\n  <div stayMgmtContentHeight [fromParent]='true' (contentHeight)=\"contentHeight($event)\">\n    <ng-content></ng-content>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/stay-mgmt/app/components/fixed-summary-container/fixed-summary-container.component.html
// module id = ./src/main/webapp/stay-mgmt/app/components/fixed-summary-container/fixed-summary-container.component.html
// module chunks = 0